<template>
  <div style="height: 100%;">
    <el-container style="height: 100%;">
      <el-header style="height: 58px;padding-top: 5px;border-bottom: 2px solid #409EFF;text-align: center;">
        <img src="https://catering.restaurant.starpay.pe/images/logo.png" style="width: 48px;height: 48px;border-radius: 50%;float: left;" />
        <span style="font-weight: bold;font-size: 24px;padding: 10px;color: #3366FF;float: left;">StarPay</span>
        <el-badge :value="unpayedOrderCount" class="item" style="margin: 5px 20px;">
          <el-button size="small" @click="showTableManage">{{ $t('label.unpayed') }}</el-button>
        </el-badge>
        <el-select v-model="currentTableId" :placeholder="$t('label.tableNumber')" style="width: 150px;" @change="changeTable">
          <el-option
            v-for="t in allTables"
            :key="t.id"
            :label="t.number"
            :value="t.id">
          </el-option>
        </el-select>
        <el-input ref="searchInput" v-model="listQuery.searchName" @input="delayFetchFood" clearable style="width: 200px;margin-left: 5px;width: 250px;" :placeholder="$t('label.search')"></el-input>
        <el-checkbox v-model="autoSelect">{{ $t('label.autoSelect') }}</el-checkbox>
        <el-select v-model="currentLang" style="float: right;width: 100px;" :placeholder="$t('label.lang')" @change="selectLang">
          <el-option label="Español" value="es"></el-option>
          <el-option label="中文" value="zh"></el-option>
        </el-select>
        <el-button type="primary" style="float: right;margin-right: 5px;" @click="reload">{{ $t('label.reset') }}</el-button>
        <el-button type="primary" style="float: right;margin-right: 5px;" @click="openCustomer">{{ $t('label.customer') }}</el-button>
        <el-button v-if="needServicePassword&&!loginedServer" type="success" style="float: right;margin-right: 5px;" @click="loginVisible=true">{{ $t('label.login') }}</el-button>
        <el-button v-else-if="needServicePassword&&loginedServer" type="success" style="float: right;margin-right: 5px" @click="logout">{{ loginedServer }}</el-button>
      </el-header>
      <el-container>
        <el-aside style="width: 20%;">
          <div v-for="spec,index in selectedSpec" :key="index" class="selected-food-block">
            <div class="sort" @click="deleteSpec(spec.specId)">{{ index + 1 }}</div>
            <div>
              <p class="name">{{ spec.name }}</p>
              <p class="des">{{ spec.des }}</p>
            </div>
            <div class="price-count">
              <span class="price">S/. {{ parseFloat((spec.unitPrice * spec.count + spec.adjustPrice * spec.count + spec.selfAdjustPrice * spec.count).toFixed(2)) }}</span>
              <el-input-number size="small" v-model="spec.count" :min="1" @change="refreshInfo4Customer"></el-input-number>
            </div>
          </div>
        </el-aside>
        <el-container>
          <el-main class="product-select">
            <div class="group-select">
              <el-button v-for="p in allPacks" :key="p.id" size="medium" :type="listQuery.packId==p.id?'primary':''" @click="selectPack(p.id)">{{ p.name }}</el-button>
            </div>
            <div class="food-part">
              <div class="food-list">
                <div v-for="f in foods" :key="f.id" class="food-item" @click="selectFood(f)">
                  <img :src="f.pic" />
                  <p class="food-name">{{ f.name.length > 23 ? f.name.substr(0, 23) + '...' : f.name }}</p>
                  <p class="food-price">S/. {{ f.topPrice > f.bottomPrice ? f.bottomPrice + '~' + f.topPrice : f.bottomPrice }}</p>
                </div>
              </div>
              <div class="food-spec">
                <p>
                  {{ selectedFood.name }}
                  <span class="price">S/. {{ (selectedFood.bottomPrice + orderInfo.adjustPrice + parseFloat(orderInfo.selfAdjustPrice)).toFixed(2) }}</span>
                </p>
                <div>
                  <el-button v-for="spec in selectedFood.specs" :key="'spec'+spec.id" :type="orderInfo.specId==spec.id?'primary':''" size="mini" @click="selectSpec(spec.id,spec.unitPrice)">{{ spec.name }}</el-button>
                </div>
                <div v-for="sideFood in selectedFood.sideFood" :key="'category'+sideFood.categoryId">
                  <p style="font-size:14px;margin:5px;">{{ sideFood.category }}</p>
                  <el-button v-for="sideContent in sideFood.contents" style="margin-bottom: 10px; padding: 8px" :key="'content'+sideContent.id" :type="orderInfo.sideFoodIds.includes(sideContent.id)?'primary':''" size="mini" @click="selectSideContent(sideContent,sideFood.selectCount,sideFood.categoryId)">{{ sideContent.name }}</el-button>
                </div>
                <div v-if="selectedFood.selectPeroFood" style="margin-top: 10px;padding: 5px;border-top: 1px solid #409EFF;">
                  <el-button v-for="fa in foodAdjust" style="margin-bottom: 8px;margin-left: 5px; padding: 5px" :key="'adjust'+fa.id" :type="orderInfo.adjustIds.includes(fa.id)?'primary':''" size="mini" @click="selectFoodAdjust(fa)">{{ fa.name }} {{ fa.price || 0 }}</el-button>
                  <!-- <el-button v-for="fa in foodAdjust.filter(fa => fa.price > 0)" style="margin-bottom: 5px;margin-left: 5px; padding: 5px" :key="'adjust'+fa.id" :type="orderInfo.adjustIds.includes(fa.id)?'primary':''" size="mini" @click="selectFoodAdjust(fa)">{{ fa.name }} {{ fa.price || 0 }}</el-button> -->
                </div>
                <!-- <div v-if="selectedFood.selectPeroFood && foodAdjust.filter(fa => !(fa.price > 0)).length > 0" style="padding: 5px;border-top: 1px dashed #E4E7ED;">
                  <el-button v-for="fa in foodAdjust.filter(fa => !(fa.price > 0))" style="margin-bottom: 5px;margin-left: 5px; padding: 5px" :key="'adjust'+fa.id" :type="orderInfo.adjustIds.includes(fa.id)?'primary':''" size="mini" @click="selectFoodAdjust(fa)">{{ fa.name }} {{ fa.price || 0 }}</el-button>
                </div> -->
                <div v-if="selectedFood.selectPeroFood" style="text-align: right;">
                  <el-input v-model="orderInfo.selfAdjustItem" :placeholder="$t('label.custom')"></el-input>
                  <el-input-number v-model="orderInfo.selfAdjustPrice" :precision="1" :step="0.5" :min="0" style="margin-top: 5px;"></el-input-number>
                </div>
                <div style="text-align: right;">
                  <el-button v-if="orderInfo.specId" type="success" round @click="addSpec" style="margin-top: 10px;">{{ $t('label.add') }}</el-button>
                </div>
              </div>
            </div>
          </el-main>
          <el-footer style="background-color: #E6A23C;padding-top: 10px;">
            <span style="font-weight: bold;padding-right: 10px;">{{ $t('label.total') }}:S/. {{ parseFloat(selectedSpec.reduce((ac, ci) => ac + ci.unitPrice * ci.count + ci.adjustPrice * ci.count + ci.selfAdjustPrice * ci.count, 0).toFixed(2)) }}</span>
            <el-input v-model="note" style="width: 500px;" :placeholder="$t('label.note')"></el-input>
            <el-button :type="takeOutInfo.receiver&&takeOutInfo.phone&&takeOutInfo.address?'success':'primary'" @click="takeOutVisible=true">{{ $t('label.takeOutInfo') }}</el-button>
            <el-button type="primary" @click="checkToPay">{{ $t('label.confirmOrder') }}</el-button>
          </el-footer>
        </el-container>
      </el-container>
    </el-container>

    <el-dialog :title="$t('label.takeOutInfo')" :visible.sync="takeOutVisible">
      <el-form label-width="100px">
        <el-form-item :label="$t('label.personalName')">
          <el-input v-model="takeOutInfo.receiver" style="width: 200px;"></el-input>
          <el-button type="text" @click="searchTakeOutInfo('receiver', takeOutInfo.receiver)">{{ $t('label.search') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('label.phone')">
          <el-input v-model="takeOutInfo.phone" style="width: 200px;"></el-input>
          <el-button type="text" @click="searchTakeOutInfo('phone', takeOutInfo.phone)">{{ $t('label.search') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('label.address')">
          <el-input v-model="takeOutInfo.address"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="cancelTakeOut">{{ $t('label.cancel') }}</el-button>
          <el-button type="primary" @click="confirmTakeOut">{{ $t('label.confirm') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('label.takeOutInfo')+'-'+$t('label.search')" :visible.sync="searchTakeOutVisible">
      <div v-for="to in queryedTakeOutInfo" :key="to.id" style="margin-bottom: 10px;">
        <el-button @click="selectTakeOutInfo(to.id)" style="width: 100%;">{{ to.receiver }}/{{ to.phone }}/{{ to.address }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('label.confirmToPay')" :visible.sync="payVisible" :top="'0'">
      <el-form label-width="100px" size="small">
        <el-form-item :label="$t('label.discount')" v-if="!memberInfo.use">
          <el-input v-model="payInfo.discount" style="width: 60px;" @input="updateDiscountAmount()"></el-input>%
          <el-input v-model="payInfo.discountAmount" style="width: 80px;" @input="updateDiscountRate()"></el-input>S/.
        </el-form-item>
        <el-form-item :label="$t('label.password')" v-if="!memberInfo.use">
          <el-input v-model="payInfo.discountPassword" show-password style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('label.payMethod')">
          <el-radio v-model="payInfo.payMethod" :label="0">{{ $t('label.cash') }}</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="4">POS-VISA</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="5">POS-MASTER</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="6">{{ $t('label.transfer') }}</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="7">Yape</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="9">Plim</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="20">Didi</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="21">Pedidoya</el-radio>
          <el-radio v-model="payInfo.payMethod" :label="22">Rapi</el-radio>
        </el-form-item>
        <el-form-item v-if="payInfo.payMethod!=0" :label="$t('label.payCode')">
          <el-input v-model="payInfo.payCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('label.starPayDiscount')" v-if="!memberInfo.use">
          <el-input v-model="payInfo.starPayAmount4Discount" style="width: 80px;"></el-input>S/.
          <el-input v-model="payInfo.starPayCode4Discount" style="width: 160px;" :placeholder="$t('label.discountCode')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('label.needPayBill')">
          <el-checkbox v-model="needDeclare"></el-checkbox>
        </el-form-item>
        <el-form-item :label="$t('label.waiter')">
          <el-select v-model="waiterId" style="width: 150px;" @change="(val) => waiterId=val">
            <el-option
              v-for="t in allWaiters"
              :key="t.id"
              :label="t.name"
              :value="t.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('label.member')">
          <el-input v-model="memberInfo.codeOrPhone" style="width: 150px;" :placeholder="$t('label.memberTip')"></el-input>
          <el-input type="password" v-model="memberInfo.password" style="width: 150px;" :placeholder="$t('label.password')"></el-input>
          <el-checkbox v-model="memberInfo.use" @change="changeUseMember"></el-checkbox>
          <span style="font-size: 18px;" v-if="memberInfo.id>0">{{ memberInfo.name }} <span style="color: red;">{{ memberInfo.amount }}SOL {{ memberInfo.discount }}%</span></span>
        </el-form-item>
        <el-form-item v-if="needDeclare" :label="$t('label.type')">
          <el-radio v-model="payInfo.billType" :label="0">{{ $t('label.receipt') }}</el-radio>
          <el-radio v-model="payInfo.billType" :label="1">{{ $t('label.invoice') }}</el-radio>
        </el-form-item>
        <el-form-item v-if="needDeclare" :label="payInfo.billType==0?$t('label.idNumber'):$t('label.taxNumber')">
          <el-input v-model="payInfo.dniRuc" style="width: 200px;"></el-input>
          <el-button type="primary" @click="checkDniRuc">{{ $t('label.check') }}</el-button>
        </el-form-item>
        <el-form-item v-if="needDeclare" :label="payInfo.billType==0?$t('label.personalName'):$t('label.companyName')">
          <el-input v-model="payInfo.name"></el-input>
        </el-form-item>
        <el-form-item v-if="needDeclare&&payInfo.billType==1" :label="$t('label.companyAddress')">
          <el-input v-model="payInfo.address"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payVisible=false">{{ $t('label.cancel') }}</el-button>
        <el-button type="primary" @click="confirmOrder" :loading="ordering">{{ $t('label.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('label.login')" :visible.sync="loginVisible" width="500px">
      <el-form label-width="100px">
        <el-form-item :label="$t('label.password')">
          <el-input show-password v-model="servicePassword" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirmLogin">{{ $t('label.confirm') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { checkAccount, serverLogin, getAllTables, getAllWaiters, getAllFoodPack, queryFood, checkRucDni, getFoodAdjust, searchTakeOutInfo, getUnPayedOrderCount, checkMember } from '@/api/getInfo'
import { checkDiscountPasswrod, procedure, order, payed, declareTax, saveTakeOutInfo } from '@/api/order'

export default {
  data() {
    return {
      currentLang: localStorage.getItem('lang') || 'es',
      restaurant: {
        id: 0,
        userName: '',
        userId: 0
      },
      listQuery: {
        restaurantUserId: 0,
        packId: 0,
        searchName: null,
      },
      querying: false,
      autoSelect: true,
      currentTableId: 0,
      currentTableNumber: '',
      unpayedOrderCount: 0,
      payVisible: false,
      loginVisible: false,
      servicePassword: '',
      loginedServer: localStorage.getItem('loginedServer') || '',
      needServicePassword: false,
      takeOutVisible: false,
      takeOutInfo: {
        deliverInfoId: 0,
        receiver: '',
        phone: '',
        address: ''
      },
      searchTakeOutVisible: false,
      queryedTakeOutInfo: [],
      needDeclare: false,
      payInfo: {
        billType: 0,
        payMethod: 0,
        payCode: '',
        dniRuc: '',
        name: '',
        address: '',
        discount: '',
        discountAmount: '',
        discountPassword: '',
        starPayAmount4Discount: '',
        starPayCode4Discount: '',
      },
      memberInfo: {
        id: 0,
        codeOrPhone: '',
        password: '',
        use: false,
        name: '',
        amount: 0,
        discount: 0,
      },
      allTablesWithDelivery: [], // 包含外卖桌号
      allTables: [], // 不包含外卖桌号
      allWaiters: [],
      waiterId: '',
      selectedSpec: [],
      allPacks: [],
      foods: [],
      foodAdjust: [],
      selectedFood: {
        bottomPrice: 0,
        adjustIds: [],
      },
      // 选择的菜品下单信息
      orderInfo: {
        pic: '',
        specId: 0,
        unitPrice: 0,
        sideFoodIds: [],
        sideFoodNames: [],
        sideFoodCategoryIds: [],
        adjustIds: [],
        adjustNames: [],
        adjustPrice: 0,
        selfAdjustItem: '',
        selfAdjustPrice: 0,
      },
      note: '',
      ordering: false,
      customerWindow: null
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$refs.searchInput.focus()
    setInterval(this.fetchUnpayedOrderCount, 5000);
  },
  methods: {
    initData() {
      const {
        restaurant,
        key,
        tableNumber
      } = this.$route.query
      // 简单校验账号
      checkAccount({ name: restaurant, key: key }).then(res => {
        if (res.restaurantId) {
          // 有效，本地保存信息
          this.restaurant.id = res.restaurantId
          this.restaurant.userId = res.userId
          this.restaurant.userName = res.userName
          this.needServicePassword = res.needServicePassword
          // 查询所有桌号
          getAllTables({ restaurantId: res.restaurantId }).then(tableRes => {
            this.allTablesWithDelivery = tableRes
            tableRes.forEach(t => {
              if (t.number.indexOf('Delivery') == -1) {
                this.allTables.push(t)
              }
            })
            if (tableNumber) {
              this.allTables.forEach(t => {
                if (t.number == tableNumber) {
                  this.currentTableId = t.id
                  this.currentTableNumber = tableNumber
                }
              })
            } else {
              this.currentTableId = this.allTables[0].id
              this.currentTableNumber = this.allTables[0].number
            }
          })
          // 查询所有服务员
          getAllWaiters({ restaurantId: res.restaurantId }).then(waiterRes => {
            this.allWaiters = waiterRes
          })
          // 查询所有产品包
          getAllFoodPack({ restaurantId: this.restaurant.id }).then(packRes => {
            this.allPacks = [{
              id: 0,
              name: this.$t('label.all')
            }]
            packRes.forEach(p => this.allPacks.push({
              id: p.id,
              name: p.name,
            }))
          })
          // 查询产品
          this.listQuery.restaruantUserId = this.restaurant.userId
          queryFood(this.listQuery).then(foodRes => {
            this.foods = foodRes
          })
          // 菜品调整信息
          getFoodAdjust({ restaurantId: this.restaurant.id }).then(adjustRes => {
            this.foodAdjust = adjustRes.items
          })
        }
      })
    },
    getCurrentDeliveryTable() {
      if (this.currentTableNumber) {
        let currentDeliveryTable
        this.allTablesWithDelivery.forEach(t => {
          if (t.number == 'Delivery' + this.currentTableNumber) {
            // 默认外卖桌号和点餐桌号对应，如果点餐桌号是001，则外卖桌号就是Delivery001
            currentDeliveryTable = t
          }
        })
        return currentDeliveryTable
      } else {
        return null
      }
    },
    fetchUnpayedOrderCount() {
      const currentDeliveryTable = this.getCurrentDeliveryTable()
      if (currentDeliveryTable) {
        getUnPayedOrderCount({
          restaurantId: this.restaurant.id,
          tableId: currentDeliveryTable.id
        }).then(res => {
          this.unpayedOrderCount = res
        })
      }
    },
    showTableManage() {
      window.open(process.env.MANAGE_URL)
    },
    confirmLogin() {
      serverLogin({
        restaurantId: this.restaurant.id,
        password: this.servicePassword,
      }).then(res => {
        if (res.success) {
          this.loginedServer = res.waiterName
          localStorage.setItem('loginedServer', res.waiterName)
          this.loginVisible = false
        } else {
          this.$message({
            message: this.$t('message.error'),
            type: 'warning'
          })
        }
      })
    },
    logout() {
      this.loginedServer = ''
      localStorage.setItem('loginedServer', '')
    },
    openCustomer() {
      window.open(process.env.CUSTOMER_URL + '?restaurantId=' + this.restaurant.id)
    },
    refreshInfo4Customer() {
      const channel = new BroadcastChannel('customerChannel')
      channel.postMessage(this.selectedSpec)
    },
    reload() {
      location.reload()
    },
    selectLang(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.initData()
    },
    deleteSpec(specId) {
      this.$confirm(this.$t('message.confirmDelete'), this.$t('message.promopt'), {
        confirmButtonText: this.$t('label.confirm'),
        cancelButtonText:  this.$t('label.cancel'),
        type: 'warning'
      }).then(() => {
        for (let i = 0; i < this.selectedSpec.length; i ++) {
          if (this.selectedSpec[i].specId == specId) {
            this.selectedSpec.splice(i, 1)
            break
          }
        }
        this.refreshInfo4Customer()
      }).catch(() => {
      })
    },
    fetchFood() {
      if (!this.querying) {
        queryFood(this.listQuery).then(foodRes => {
          if (foodRes.length == 1 && !foodRes[0].selectPeroFood && foodRes[0].sideFood.length == 0
          && foodRes[0].specs.length == 1 && this.autoSelect) {
            // 如果搜索出来只有一个商品，一个规格，没有配餐选择，并且不能选择调整秘鲁餐，设置了自动下单就直接添加到待结算
            this.selectFood(foodRes[0])
            this.addSpec()
            this.listQuery.searchName = ''
          } else {
            this.foods = foodRes
          }
        })
        this.querying = true
        setTimeout(() => this.querying = false, 800)
      }
    },
    delayFetchFood() {
      setTimeout(() => this.fetchFood(), 800)
    },
    changeTable(tableId) {
      this.allTables.forEach(t => {
        if (t.id == tableId) {
          this.currentTableNumber = t.number
        }
      })
    },
    selectPack(packId) {
      this.listQuery.packId = packId
      queryFood(this.listQuery).then(foodRes => {
        this.foods = foodRes
      })
    },
    selectFood(food) {
      if (this.needServicePassword && !this.loginedServer) {
        this.$message({
          message: this.$t('message.loginFirst'),
          type: 'warning'
        })
        return
      }
      this.selectedFood = food
      if (food.specs.length == 1) {
        // 如果只有一个规格，默认选中
        this.orderInfo.specId = food.specs[0].id
        this.orderInfo.unitPrice = food.specs[0].unitPrice
      } else {
        this.orderInfo.specId = 0
        this.orderInfo.unitPrice = 0
      }
      this.orderInfo.pic = food.pic
      this.orderInfo.sideFoodIds = []
      this.orderInfo.sideFoodNames = []
      this.orderInfo.sideFoodCategoryIds = []
      this.selectedFood.sideFood.forEach(sf => {
        if (sf.contents.length > 0) {
          this.orderInfo.sideFoodIds.push(sf.contents[0].id)
          this.orderInfo.sideFoodNames.push(sf.contents[0].name)
          this.orderInfo.sideFoodCategoryIds.push(sf.categoryId)
        }
      })
      this.orderInfo.adjustIds = []
      this.orderInfo.adjustNames = []
      this.orderInfo.adjustPrice = 0
      this.orderInfo.selfAdjustItem = ''
      this.orderInfo.selfAdjustPrice = 0
    },
    selectSpec(specId, unitPrice) {
      this.orderInfo.specId = specId
      this.orderInfo.unitPrice = unitPrice
    },
    selectSideContent(content, canSelectCount, categoryId) {
      const contentIdIndex = this.orderInfo.sideFoodIds.indexOf(content.id)
      if (contentIdIndex > -1) {
        this.orderInfo.sideFoodIds.splice(contentIdIndex, 1)
        this.orderInfo.sideFoodNames.splice(contentIdIndex, 1)
        this.orderInfo.sideFoodCategoryIds.splice(contentIdIndex, 1)
      } else {
        this.orderInfo.sideFoodIds.push(content.id)
        this.orderInfo.sideFoodNames.push(content.name)
        this.orderInfo.sideFoodCategoryIds.push(categoryId)
        if (this.orderInfo.sideFoodCategoryIds.filter(cid => cid == categoryId).length > canSelectCount) {
          const categoryIndex = this.orderInfo.sideFoodCategoryIds.indexOf(categoryId)
          this.orderInfo.sideFoodIds.splice(categoryIndex, 1)
          this.orderInfo.sideFoodNames.splice(categoryIndex, 1)
          this.orderInfo.sideFoodCategoryIds.splice(categoryIndex, 1)
        }
      }
    },
    selectFoodAdjust(foodAdjust) {
      const adjustIndex = this.orderInfo.adjustIds.indexOf(foodAdjust.id)
      if (adjustIndex > -1) {
        this.orderInfo.adjustIds.splice(adjustIndex, 1)
        this.orderInfo.adjustNames.splice(adjustIndex, 1)
        this.orderInfo.adjustPrice = parseFloat((this.orderInfo.adjustPrice - foodAdjust.price).toFixed(2))
      } else {
        this.orderInfo.adjustIds.push(foodAdjust.id)
        this.orderInfo.adjustNames.push(foodAdjust.name)
        this.orderInfo.adjustPrice = parseFloat((this.orderInfo.adjustPrice + foodAdjust.price).toFixed(2))
      }
    },
    addSpec() {
      // 如果有添加过相同的规格，则直接加数量
      let added = false
      this.selectedSpec.forEach(spec => {
        if (spec.specId == this.orderInfo.specId && spec.sideFoodIds.length == this.orderInfo.sideFoodIds.length
        && spec.adjustIds.length == this.orderInfo.adjustIds.length) {
          if (spec.sideFoodIds.every(sf => this.orderInfo.sideFoodIds.indexOf(sf) > -1)
          && spec.adjustIds.every(a => this.orderInfo.adjustIds.indexOf(a) > -1)
          && spec.selfAdjustItem == this.orderInfo.selfAdjustItem && spec.selfAdjustPrice == this.orderInfo.selfAdjustPrice) {
            spec.count++
            added = true
          }
        }
      })
      // 第一次添加，补充数据
      if (!added) {
        let tempAdjustName = [...this.orderInfo.adjustNames]
        if (this.orderInfo.selfAdjustItem) {
          tempAdjustName.push(this.orderInfo.selfAdjustItem)
        }
        this.selectedSpec.push({
          pic: this.orderInfo.pic,
          specId: this.orderInfo.specId,
          name: this.selectedFood.name,
          des: (tempAdjustName.length > 0 ? '[' + tempAdjustName + ']' : '') + this.orderInfo.sideFoodNames,
          unitPrice: this.orderInfo.unitPrice,
          sideFoodIds: [...this.orderInfo.sideFoodIds],
          adjustIds: [...this.orderInfo.adjustIds],
          adjustPrice: this.orderInfo.adjustPrice,
          selfAdjustItem: this.orderInfo.selfAdjustItem,
          selfAdjustPrice: parseFloat(this.orderInfo.selfAdjustPrice),
          count: 1
        })
      }
      this.refreshInfo4Customer()
    },
    searchTakeOutInfo(searchItem, searchContent) {
      if (!searchContent) {
        return
      }
      const searchData = {
        restaurantId: this.restaurant.id
      }
      searchData[searchItem] = searchContent
      searchTakeOutInfo(searchData).then(res => {
        if (res.infos.length == 0) {
          // 没有记录
          this.$message({
            message: this.$t('message.noRecord'),
            type: 'warning'
          })
        } else if (res.infos.length == 1) {
          // 直接填写外卖信息
          this.takeOutInfo.receiver = res.infos[0].receiver
          this.takeOutInfo.phone = res.infos[0].phone
          this.takeOutInfo.address = res.infos[0].address
          this.takeOutInfo.deliverInfoId = res.infos[0].id
        } else {
          this.queryedTakeOutInfo = res.infos
          this.searchTakeOutVisible = true
        }
      })
    },
    selectTakeOutInfo(id) {
      this.queryedTakeOutInfo.forEach(to => {
        if (to.id == id) {
          this.takeOutInfo.receiver = to.receiver
          this.takeOutInfo.phone = to.phone
          this.takeOutInfo.address = to.address
          this.takeOutInfo.deliverInfoId = to.id
        }
      })
      this.searchTakeOutVisible = false
    },
    cancelTakeOut() {
      this.takeOutInfo.receiver = ''
      this.takeOutInfo.phone = ''
      this.takeOutInfo.address = ''
      this.takeOutInfo.deliverInfoId = 0
      this.takeOutVisible = false
    },
    confirmTakeOut() {
      if (this.takeOutInfo.receiver && this.takeOutInfo.phone && this.takeOutInfo.address) {
        const subData = {...this.takeOutInfo}
        subData.restaurantId = this.restaurant.id
        subData.billInfo = '' // 开票信息，比较多余，可以使用订单上的开票信息
        saveTakeOutInfo(subData).then(res => {
          this.takeOutInfo.deliverInfoId = res.id
        })
        this.takeOutVisible = false
      } else {
        this.$message({
          message: this.$t('message.needMoreInfo'),
          type: 'warning'
        })
      }
    },
    cancelMemberUser() {
      this.memberInfo.id = 0
      this.memberInfo.codeOrPhone = ''
      this.memberInfo.password = ''
      this.memberInfo.use = false
    },
    checkToPay() {
      this.cancelMemberUser()
      if (this.needServicePassword && !this.loginedServer) {
        this.$message({
          message: this.$t('message.loginFirst'),
          type: 'warning'
        })
        return
      }
      if (this.selectedSpec.length > 0) {
        this.payVisible = true
        this.payInfo.discount = ''
        this.payInfo.discountAmount = ''
        this.payInfo.starPayAmount4Discount = ''
        this.payInfo.starPayCode4Discount = ''
      } else {
        this.$message({
          message: this.$t('message.addFood'),
          type: 'warning'
        })
      }
    },
    checkDniRuc() {
      checkRucDni({ rucdni: this.payInfo.dniRuc }).then(res => {
        this.payInfo.name = res.name
        this.payInfo.address = res.address
      })
    },
    getTotal() {
      return parseFloat(this.selectedSpec.reduce((ac, ci) => ac + ci.unitPrice * ci.count + ci.adjustPrice * ci.count + ci.selfAdjustPrice * ci.count, 0).toFixed(2))
    },
    updateDiscountAmount() {
      if (this.payInfo.discount > 0 && this.payInfo.discount < 100) {
        this.payInfo.discountAmount = parseFloat((this.getTotal() * this.payInfo.discount / 100).toFixed(2))
      } else {
        this.payInfo.discount = ''
        this.payInfo.discountAmount = ''
      }
    },
    updateDiscountRate() {
      const totalPrice = this.getTotal()
      if (this.payInfo.discountAmount > 0 && this.payInfo.discountAmount < totalPrice) {
        this.payInfo.discount = parseFloat((this.payInfo.discountAmount / totalPrice * 100).toFixed(1))
      } else {
        this.payInfo.discount = ''
        this.payInfo.discountAmount = ''
      }
    },
    changeUseMember(isUse) {
      if (isUse) {
        checkMember({
          restaurantId: this.restaurant.id,
          codeOrPhone: this.memberInfo.codeOrPhone,
          password: this.memberInfo.password
        }).then(res => {
          if (res.member.id > 0 && res.isValid) {
            this.memberInfo.id = res.member.id
            this.memberInfo.name = res.member.name
            this.memberInfo.amount = res.member.amount
            this.memberInfo.discount = res.member.discount * 100
          } else {
            this.memberInfo.use = false
            if (res.member.id > 0) {
              this.$message({
                message: this.$t('message.membershipLapsed'),
                type: 'warning'
              })
            } else {
              this.$message({
                message: this.$t('message.error'),
                type: 'warning'
              })
            }
          }
        })
      } else {
        this.cancelMemberUser()
      }
    },
    async confirmOrder() {
      this.ordering = true
      // 如果使用了会员，判断会员能否使用
      if (this.memberInfo.use) {
        const memberResult = await checkMember({
          restaurantId: this.restaurant.id,
          codeOrPhone: this.memberInfo.codeOrPhone,
          password: this.memberInfo.password
        })
        if (!(memberResult.member.id > 0 && memberResult.isValid)) {
          this.$message({
            message: this.$t('message.error'),
            type: 'warning'
          })
          this.ordering = false
          return
        }
        // 合计金额，算法同上
        const totalPrice = parseFloat(this.selectedSpec.reduce((ac, ci) => ac + ci.unitPrice * ci.count + ci.adjustPrice * ci.count + ci.selfAdjustPrice * ci.count, 0).toFixed(2))
        if (memberResult.member.amount < totalPrice * (1 - memberResult.member.discount || 0)) {
          this.$message({
            message: this.$t('message.notEnoughMemberBalance'),
            type: 'warning'
          })
          this.ordering = false
          return
        }
      } else if (this.payInfo.discount) {
        // 优先判断折扣密码，如果折扣密码不正确，会生成生产单，再生成订单的时候报错
        if (this.payInfo.discount > 0 && this.payInfo.discount < 100) {
          const checkResult = await checkDiscountPasswrod({
            restaurantId: this.restaurant.id,
            discountPassword: this.payInfo.discountPassword
          })
          if (!checkResult.passwordRight) {
            this.$message({
              message: checkResult.msg,
              type: 'warning'
            })
            this.ordering = false
            return
          }
        } else {
          this.ordering = false
          this.$message({
            message: this.$t('message.discountError'),
            type: 'warning'
          })
          return
        }
      }
      const isTakeOut = this.takeOutInfo.receiver && this.takeOutInfo.phone && this.takeOutInfo.address
      let currentDeliveryTable = this.getCurrentDeliveryTable()
      const specs = this.selectedSpec.map(spec => {
        const item = {
          specId: spec.specId,
          count: spec.count,
          sideFoodIds: spec.sideFoodIds,
          adjustInfos: [], // 秘鲁餐调整
        }
        spec.adjustIds.forEach(sfaId => {
          this.foodAdjust.forEach(fa => {
            if (sfaId == fa.id) {
              item.adjustInfos.push({
                operationId: 2, // 操作“添加”默认id
                peruFoodItemId: fa.id,
                peruFoodItemName: fa.name,
                count: fa.price * 10, // 调整单价是0.1，如果价格是10，就是10/0.1
              })
            }
          })
        })
        if (spec.selfAdjustItem) {
          item.adjustInfos.push({
            operationId: 2, // 操作“添加”默认id
            peruFoodItemId: -1,
            peruFoodItemName: spec.selfAdjustItem,
            count: spec.selfAdjustPrice * 10,
          })
        }
        return item
      })
      // 生成生产单
      procedure({
        restaurantId: this.restaurant.id,
        tableNumber: isTakeOut ? currentDeliveryTable.number : this.currentTableNumber,
        foodSpecifications: JSON.stringify(specs),
        note: isTakeOut ? 
          this.note + '\r\n' + 'Delivery:\r\n' + this.takeOutInfo.receiver + '\r\n' + this.takeOutInfo.phone + '\r\n' + this.takeOutInfo.address :
          this.note,
        serviceNote: this.loginedServer || this.restaurant.userName,
        deliverInfoId: this.takeOutInfo.deliverInfoId,
        needPrint: true, // 是否需要打印生产单
        isFastFood: 1,
      }).then(res => {
        // 生产单号
        return order({
          orderInfo: {
            tableId: isTakeOut ? currentDeliveryTable.id : this.currentTableId,
            batchNumbers: res.allBatchNumbers.join(','),
            selectedDishInfos: JSON.stringify([]),
            printBizId: this.restaurant.id.toString(),
            orderDiscount: this.payInfo.discount / 100,
            discountPassword: this.payInfo.discountPassword,
            billType: this.payInfo.billType,
            billToName: this.payInfo.name || 'aa',
            billToTaxNo: this.payInfo.dniRuc || '00000000',
            billToAddress: this.payInfo.address,
            serviceNote: this.loginedServer || this.restaurant.userName,
            printZhDishName: 'true', // 先默认都打印
            waiterId: this.waiterId,
          },
          userInfo: {
            userId: this.restaurant.userId,
            restaurantId: this.restaurant.id
          }
        })
      }).then(res => {
        if (isTakeOut) {
          // console.log('是外卖')
          // 如果是外卖不需要设置为已付款
          if (this.needDeclare) {
            // console.log('需要申报')
            return declareTax({
              billInfo: {
                orderId: res.orderId,
                billType: this.payInfo.billType,
                billToName: this.payInfo.name || 'aa',
                billToTaxNo: this.payInfo.dniRuc || '00000000',
                billToAddress: this.payInfo.address,
              },
              userInfo: {
                userId: this.restaurant.userId,
                restaurantId: this.restaurant.id
              }
            })
          } else {
            return true
          }
        } else {
          let payRecords = []
          if (this.memberInfo.use) {
            payRecords.push({
              type: 10,
              amount: res.needPayAmount, // 订单金额
              payCode: '',
              count: 1,
            })
          } else {
            payRecords.push({
              type: this.payInfo.payMethod,
              amount: this.payInfo.starPayAmount4Discount > 0 ? (res.needPayAmount - this.payInfo.starPayAmount4Discount).toFixed(2) : res.needPayAmount, // 只用一种付款方式，需付款金额使用服务端生成的订单金额，这里包括所有的折扣计算
              payCode: this.payInfo.payMethod == 0 ? '' : this.payInfo.payCode,
              count: 1,
            })
            if (this.payInfo.starPayAmount4Discount > 0) {
              payRecords.push({
                type: 1, // starpay点数付款方式，以starpay点数来记录优惠券
                amount: this.payInfo.starPayAmount4Discount, // 只用一种付款方式，需付款金额使用服务端生成的订单金额，这里包括所有的折扣计算
                payCode: this.payInfo.starPayCode4Discount,
                count: 1,
              })
            }
          }
          return payed({
            payInfo: {
              id: res.orderId,
              subData: JSON.stringify(payRecords),
              billType: this.payInfo.billType,
              billToName: this.payInfo.name || 'aa',
              billToTaxNo: this.payInfo.dniRuc || '00000000',
              billToAddress: this.payInfo.address,
              notTax: this.needDeclare ? 'false' : 'true',
              memberNumberOrPhone: this.memberInfo.codeOrPhone,
              memberPassword: this.memberInfo.password,
            },
            userInfo: {
              userId: this.restaurant.userId,
              restaurantId: this.restaurant.id
            },
          })
        }
      }).then(res => {
        this.selectedSpec = []
        this.payInfo.billType = 0
        this.payInfo.payMethod = 0
        this.payInfo.dniRuc = ''
        this.payInfo.name = ''
        this.payInfo.address = ''
        this.payInfo.discount = ''
        this.payInfo.discountPassword = ''
        this.payInfo.starPayAmount4Discount = ''
        this.payInfo.starPayCode4Discount = ''
        this.note = ''
        this.takeOutInfo.receiver = ''
        this.takeOutInfo.phone = ''
        this.takeOutInfo.address = ''
        this.takeOutInfo.deliverInfoId = 0
        this.ordering = false
        this.payVisible = false
        this.$message({
          message: '已下单！',
          type: 'success'
        })
        this.refreshInfo4Customer()
      }).catch(err => {})
    }
  }
}
</script>

<style>
.selected-food-block {
  height: 100px;
  border-bottom: 1px solid #E4E7ED;
  padding: 5px;
  position: relative;
  padding-right: 5px;
}
.selected-food-block .sort {
    float: left;
    width: 20px;
    background-color: #F56C6C;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
}
.selected-food-block .name {
  margin: 0;
  font-weight: bold;
  font-size: 16px;
  color: #303133;
  text-align: left;
  padding-left: 30px;
}
.selected-food-block .des {
  margin: 0;
  font-size: 14px;
  color: #909399;
  text-align: left;
  padding-left: 30px;
  margin-top: 5px;
}
.selected-food-block .price-count {
  width: 100%;
  text-align: right;
  position: absolute;
  bottom: 5px;
  right: 5px;
  padding-right: 5px;
}
.selected-food-block .price {
  color: #F56C6C;
  font-weight: bold;
  padding-right: 5px;
}
.product-select {
  background-color: #E4E7ED;
  padding: 5px;
  text-align: left;
  display: flex;
  flex-direction: column;
}
.group-select {
  height: 85px;
  overflow: auto;
}
.food-part {
  flex-grow: 1;
  overflow-y: auto;
}
.food-list {
  float: left;
  width: 70%;
  height: calc(100vh - 220px);
  overflow-y: auto;
}
.food-spec {
  float: right;
  width: 29%;
  height: calc(100vh - 220px);
  overflow-y: auto;
  background-color: #FFFFFF;
  padding-left: 5px;
  padding-right: 5px;
}
.food-spec .price{
  color: #F56C6C;
  font-weight: bold;
  padding-right: 5px;
  float: right;
}
.food-item {
  width: 200px;
  height: 200px;
  background-color: #F2F6FC;
  margin: 3px;
  border-radius: 5px;
  float: left;
  position: relative;
}
.food-item img {
  width: 100%;
  height: 150px;
}
.food-name {
  font-size: 14px;
  margin: 2px 5px;
}
.food-price {
  position: absolute;
  margin-bottom: 0px;
  bottom: 0px;
  right: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #F56C6C;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/MainOrder.vue